import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  companyInformation: {
    companyName: '',
    city: '',
    companyRegisteredName: '',
    billingAddress: '',
    isSameAsCompanyName: false,
    state: '',
    country: {
      name: '',
      id: ''
    },
    postCode: '',
    companyWebsite: ''
  },
  invoiceEmailFormat: {
    emailRecipients: [],
    ccToPm: false,
    ccToOthersChecked: false,
    ccToOthers: []
  },
  financeContactInformation: {
    personName: '',
    countryCode: '',
    phoneNumber: '',
    designation: '',
    email: ''
  },
  nonFinanceContactInformation: {
    personName: '',
    countryCode: '',
    phoneNumber: '',
    designation: '',
    email: ''
  },
  projectInformation: {
    isTherePo: 'no',
    isPoMandatory: 'no'
  },
  invoiceFormat: {
    isSaleContactNameMandatory: 'no',
    isPmNameMandatory: 'no',
    invoiceAddressedTo: 'pm',
    others: ''
  },

  isNdaSlaDocsSkipped: false,

  signatureInputType: 'upload',
  signatureImage: {
    fileLink: null,
    fileName: '',
    fileType: ''
  },
  ndaPdfData: {
    fileLink: null,
    fileName: '',
    fileType: ''
  },
  slaPdfData: {
    fileLink: null,
    fileName: '',
    fileType: ''
  }
}

export const sliceName = 'onboardingClient'

export const onboardingClientSlice = createSlice({
  name: sliceName,
  initialState,
  reducers: {


    setFormSubmitData: (state, action) => {
      const { companyInformation, financeContactInformation, nonFinanceContactInformation, invoiceEmailFormat } = action.payload
      state.companyInformation = companyInformation
      state.financeContactInformation = financeContactInformation
      state.nonFinanceContactInformation = nonFinanceContactInformation
      state.invoiceEmailFormat = { ...state.invoiceEmailFormat, ...invoiceEmailFormat }
    },
    setIsSameAsCompanyName: (state, action) => {
      const { id, value } = action.payload
      state.companyInformation[id] = value
      if (id === "isSameAsCompanyName" && value === true) {
        state.companyInformation.companyRegisteredName = ''
      }

    },
    handleInvoiceEmailAddressedToCheckboxes: (state, action) => {
      const { identifier } = action.payload
      if (identifier === "ccToPm") {
        state.invoiceEmailFormat.ccToPm = state.invoiceEmailFormat.ccToPm ? false : true
      }
      else {
        state.invoiceEmailFormat.ccToOthersChecked = state.invoiceEmailFormat.ccToOthersChecked ? false : true
      }
    },
    handleAddInvoiceEmail: (state, action) => {
      const { identifier, data } = action.payload
      if (identifier === "emailRecipients") {
        state.invoiceEmailFormat.emailRecipients = [...state.invoiceEmailFormat.emailRecipients, data]
      }
      else {
        state.invoiceEmailFormat.ccToOthers = [...state.invoiceEmailFormat.ccToOthers, data]
      }
    },
    setProjectInformation: (state, action) => {
      const { id, value } = action.payload
      state.projectInformation[id] = value
    },

    setInvoiceFormat: (state, action) => {
      const { id, value } = action.payload
      state.invoiceFormat[id] = value
      if (id === "invoiceAddressedTo") {
        state.invoiceFormat.others = ''
      }
    },

    setNdaSignature: (state, action) => {
      const { signatureImage, signatureInputType } = action.payload
      state.signatureImage = signatureImage
      state.signatureInputType = signatureInputType
    },

    setNdaPdfFiles: (state, action) => {
      const { ndaPdfData } = action.payload
      state.ndaPdfData = ndaPdfData
    },
    setSlaPdfFiles: (state, action) => {
      const { slaPdfData } = action.payload
      state.slaPdfData = slaPdfData
    },

    setSkipNdaSlaDocs: (state, action) => {
      const { isNdaSlaDocsSkipped } = action.payload
      state.isNdaSlaDocsSkipped = isNdaSlaDocsSkipped
    },

    handleAllFormDataReset: (state) => {
      return state = initialState;
    }
  },
})

// Action creators are generated for each case reducer function
export const {
  setNdaPdfFiles,
  setSlaPdfFiles,
  setFormSubmitData,
  setIsSameAsCompanyName,
  setProjectInformation,
  setInvoiceFormat,
  setNdaSignature,
  setSkipNdaSlaDocs,
  handleAllFormDataReset,
  handleInvoiceEmailAddressedToCheckboxes,
  handleAddInvoiceEmail
} = onboardingClientSlice.actions

export const selectOnboardingClientData = state => state[sliceName];

export default onboardingClientSlice.reducer